/**
 * Mock de notificaciones enviadas hoy.
 */

export const MOCK_WHATSAPP_SENT_TODAY = 312;
export const MOCK_EMAIL_SENT_TODAY = 148;

export const MOCK_WHATSAPP_SPARK = [20, 35, 28, 40, 32, 45, 38, 50, 42, 48];
export const MOCK_EMAIL_SPARK = [10, 15, 12, 18, 14, 20, 16, 22, 19, 24];
